import * as _ from 'lodash';
import module from '../module';
import Constants from '../../../utils/CommonConstants';
import scopeUtils from '../../../utils/scope';
import {utils} from "../../../utils/shopifyInjector/utils";
import moment from 'moment';

const pages = [
    {
        id: 'login',
        fileName: 'loginPage',
        isShowBackButton: false,
        title: 'Sign In'
    },
    {
        id: 'presignup',
        fileName: 'preSignupPage',
        isShowBackButton: false,
        title: 'Sign Up'
    },
    {
        id: 'signup',
        fileName: 'signupPage',
        isShowBackButton: true,
        prevPage: 'presignup',
        title: 'Sign Up with Email'
    },
    {
        id: 'forgot',
        fileName: 'forgotPasswordPage',
        isShowBackButton: false,
        title: 'Forgot Password'
    },
    {
        id: 'message',
        fileName: 'messagePage',
        isShowBackButton: false,
        title: 'Message'
    },
    {
        id: 'facade',
        fileName: 'loginFacadePage',
        isShowBackButton: false,
        title: 'Group Order'
    },
    {
        id: 'inviteFacade',
        fileName: 'inviteFacadePage',
        isShowBackButton: false,
        title: 'Join Group Order'
    }
];

export class LoginController {
    static $inject = [
        '$scope', '$rootScope', '$state',
        'cartonomyConfig', 'LocalForageService',
        '$mdDialog', 'AuthenticationService',
        'email', 'CartService', 'currentPage', 'createOrderFlow',
        '$http', 'Message', 'Session', 'UserProfile', 'invitedCart', '$translate'
    ];

    constructor(scope, rootScope, stateService,
                cartonomyConfig, localForageService,
                dialogService, authenticationService,
                email, cartService, currentPage, createOrderFlow,
                $http, MessageService, SessionService, UserProfileService, invitedCart, $translate) {

        this._scope = scope;
        this._cartService = cartService;
        this._dialogService = dialogService;
        this._authenticationService = authenticationService;
        this._scope.emailPattern = Constants.EMAIL_REGEX;
        this._rootScope = rootScope;
        this.dialogMode = !!dialogService;
        this._cartonomyConfig = cartonomyConfig;
        this._currentPage = currentPage;
        this._stateService = stateService;
        //this._sessionStorageService = SessionStorage;
        this._localForageService = localForageService;
        this._messageService = MessageService;
        this._sessionService = SessionService;
        this._userProfileService = UserProfileService;
        this._invitedCart = invitedCart;
        this.$translate = $translate;

        scope.isExternalStore = () => this._cartonomyConfig.externalStoreMode;
        scope.openIds = this._authenticationService.getOpenIdProviders();

        scope.$on(Constants.Events.VERSION_PAGE_REQUESTED, () => {
            dialogService.cancel();
        });

        if (rootScope.retailer) {
          scope.customLoginText = rootScope.retailer.customLoginText;
        }

        this._pages = pages.map(page => {
            page.template = 'modules/shared/views/' + page.fileName + '.html';
            $http.get(page.template);
            return page;
        });

        // onboarding
        scope.onboarding = {
            steps: 5,
            currentStep: 0
        };

        scope.onboardingNextStep = () => {
            scope.onboarding.currentStep++;
        };

        scope.onboardingPreviousStep = () => {
            scope.onboarding.currentStep--;
        };

        scope.goToOnboardingStep = (step) => {
            scope.onboarding.currentStep = step;
        };


        scope.pageVersion = 0;
        scope.inProgress = false;
        scope.requestSent = false;
        scope.createOrderFlow = createOrderFlow;

        scope.credentials = {
            email: email,
            password: ''
        };

        scope.presignup = {
            email: email
        };

        scope.signup = {
            email: email,
            password: '',
            firstName: '',
            lastName: '',
            fullName: '',
            confirmPassword: ''
        };

        scope.message = '';
        scope.resetLocalCart = false;
        scope.loggingInWithOpenId = false;

        // scope.setCurrentPage = _.debounce(id => this._setCurrentPage(id), 300);
        scope.setCurrentPage = id => this._setCurrentPage(id);

        scope.cancel = () => {
            if (scope.isExternalStore()) {
                this._rootScope.toggleWindowState();
            } else {
                dialogService.cancel({
                    cancel: true
                });
            }
        };

        scope.loginOpenId = (provider) => {
            scope.loggingInWithOpenId = true;
            let externalLogin = authenticationService.externalLogin(provider);
            window.open(`${externalLogin}`, 'social_login_facebook');
        };

        scope.setForgotPage = () => {
            this._setCurrentPage('forgot');
            scope.requestSent = false;
            scope.inProgress = false;
        };

        this._continueState = '';

        scope.messageContinue = () => {
            if (this._continueState === 'signup') {
                dialogService.close();
            } else if (this._continueState === 'forget') {
                this._setCurrentPage('login');
            }
        };

        scope.login = form => this._login(form);

        scope.inputFieldKeyPressed = (event, form) => {
            if (event.which !== 13) {
                return;
            }

            scope.login(form);
        };

        scope.sendForgotRequest = form => this._sendForgotRequest(form);

        scope.preRegisterUser = form => this._preRegisterUser(form);
        scope.registerUser = form => this._registerUser(form);
        scope.cancelInvitation = () => this.cancelInvitation();
        scope.isBeingInvited = () => this.isBeingInvited();
        scope.vm = this;

        this.onOAuthResponseCallback = event => this.onOAuthResponse(event);
        window.addEventListener('message', this.onOAuthResponseCallback);

        rootScope.$on(Constants.Events.BACK_BUTTON_CLICKED, () => this._back());

        scope.$on("$destroy", function () {
            window.removeEventListener('message', scope.vm.onOAuthResponseCallback);
        });
    }

    async $onInit() {
        this._rootScope.$broadcast(Constants.Events.DIALOG_OPENED, this._currentPage && this._currentPage.isShowBackButton || false);
        if (this._invitedCart) {
            this._scope.noBudgetMode = this._rootScope.retailer && this._rootScope.retailer.noBudgetMode;
            this._scope.deadline = this._invitedCart.closeOn && moment(this._invitedCart.closeOn).format('L LT') || 'client.unlimited';
            this._scope.budget = this._invitedCart.orderLimit && this._rootScope.formatAmount(this._invitedCart.orderLimit) || 'client.unlimited';
            this._scope.orderTitle = this._invitedCart.cartName || this._invitedCart.title;
            console.log(this._invitedCart);
            this._scope.payerTitle = this._invitedCart.fulfillment && this._invitedCart.fulfillment.paymentMethod === Constants.CartDetails.PaymentMethods.SELF
            || this._invitedCart.fulfillment.paymentMethod === Constants.CartDetails.PaymentMethods.MIXED ?
                'client.order.group_member_pay' : 'client.order.group_owner_pay';
            this._setCurrentPage('inviteFacade');
        } else {
            this._rootScope.isLoggedin = false;
            this._setCurrentPage(this._currentPage || 'login');
        }
    }

    async onOAuthResponse(response) {
        if (response.data.eventType !== 'OAuthResult') {
            return;
        }
        if ((await this._sessionService.loggedIn())) {
            return;
        }

        const responseData = response.data;

        const authToken = responseData.token;
        if (!authToken && responseData.errorMessage) {
            this._messageService.showErrorPopup(responseData.errorMessage);
            this._setCurrentPage(this._currentPage || 'login');
            return;
        }

        window.removeEventListener('message', this.onOAuthResponseCallback);
        try {
            await this._authenticationService.externalLoginFinalize(authToken);
        } catch (error) {
            this._messageService.showErrorPopupForResponse(error);
            if (this.dialogMode) {
                this._dialogService.hide();
            }
            this._stateService.go(Constants.RoutingStates.CART);
            return;
        }

        await this._sessionService.clearSessionDetails();
        await this._sessionService.setSessionDetails({
            authToken: authToken,
            userEmail: await this._sessionService.getUserEmail(),
            userName: await this._sessionService.getUserName()
        });
        this._userProfileService.resetUser();
        const user = await this._userProfileService.getUser();

        await this._sessionService.setSessionDetails({
            authToken: authToken,
            userEmail: user.email,
            userName: user.fullName,
            firstName: user.firstName,
            lastName: user.lastName
        });

        await this._cartService.clearLocalCart();
        await this._cartService.resetCart();

        this._rootScope.$broadcast(Constants.Events.USER_LOGGED_IN);
        this._rootScope.storeWindowTitle = null;
        if (this.dialogMode) {
            this._dialogService.hide(true);
        }

        // let awaitingInvitation = null;
        // if(utils.hash.indexOf('#/invite/') > -1){
        //     awaitingInvitation = JSON.stringify({participantToken : utils.hash.replace('#/invite/','') });
        // }
        // if (awaitingInvitation) {
        //     this._stateService.go(Constants.RoutingStates.INVITE, JSON.parse(awaitingInvitation));
        //     return;
        // }

        let linkingSocialAccount = await this._localForageService.retrieve(Constants.SessionStorage.LINKING_SOCIAL_ACCOUNT);
        if (linkingSocialAccount) {
            await this._localForageService.remove(Constants.SessionStorage.LINKING_SOCIAL_ACCOUNT);
            this._stateService.go(Constants.RoutingStates.USER_PROFILE);
            return;
        }

        this._sessionService.setCartReference(null);
        this._stateService.go(Constants.RoutingStates.CART);
    }

    isBeingInvited() {
        this._localForageService.exists(Constants.SessionStorage.AwaitingInvitation).then((exist) => {
            return exist;
        });
    }

    cancelInvitation() {
        this._rootScope.$broadcast(Constants.Events.CANCEL_INVITATION);
    }

    _setCurrentPage(id) {
        this._scope.errorMessage = '';
        this._scope.page = this._pages.find(page => page.id === id);
        this._rootScope.storeWindowTitle = this._scope.page.title;
        console.log('Set to ' + this._scope.page.title);
        this._scope.resetLocalCart = false;
        this._rootScope.$broadcast(Constants.Events.DIALOG_OPENED, this._scope.page.isShowBackButton);
        scopeUtils.apply(this._scope);
    }

    _back() {
        if (this._scope.page.id === 'signup') {
            this._scope.presignup.email = this._scope.signup.email;
        }
        this._setCurrentPage(this._scope.page.prevPage || this._scope.page.id);
    }

    _showErrorMessage(text) {
        this._scope.errorMessage = text || this.$translate.instant('client.error.server_connect');
        scopeUtils.apply(this._scope);
    }

    async _handleLoggedIn(executor, isRegistration) {
        try {
            await executor();
            this._scope.inProgress = false;
            await this._cartService.getCart();
            this._rootScope.$broadcast(Constants.Events.USER_LOGGED_IN, isRegistration);

            if (this.dialogMode) {
                this._dialogService.hide();
                this._rootScope.storeWindowTitle = null;
            }

            // CW-2616: join order with link has bugs
            // let awaitingInvitation = null;
            // if(utils.hash.indexOf('#/invite/') > -1){
            //     awaitingInvitation = JSON.stringify({participantToken : utils.hash.replace('#/invite/','') });
            // }
            // if (awaitingInvitation) {
            //     this._stateService.go(Constants.RoutingStates.INVITE, JSON.parse(awaitingInvitation));
            //     return;
            // }
        } catch (response) {
            if (response.status === 409) { // cart merge conflict
                this._scope.resetLocalCart = true;
                this._scope.inProgress = false;
                this._showErrorMessage(this.$translate.instant('client.order.pageid', {pageId: this._scope.page.id}));
                return null;
            }

            this._scope.inProgress = false;
            const message = (response && response.status === 404) ? this.$translate.instant('client.error.invali_cred') : (response.data && response.data.message);

            this._showErrorMessage(message);
        }
    }

    _login(form) {
        if (form.$invalid) {
            form.highlightAllErrors();
            return;
        }

        this._scope.inProgress = true;
        this._scope.errorMessage = '';

        const credentials = {
            username: this._scope.credentials.email,
            password: this._scope.credentials.password
        };

        return this._handleLoggedIn(async () => await this._authenticationService.loginRequest(credentials, this._scope.resetLocalCart));
    }

    async _sendForgotRequest(form) {

        if (this._scope.inProgress) {
            return null;
        }

        if (form.$invalid) {
            form.highlightAllErrors();
            return null;
        }

        this._scope.inProgress = true;
        this._scope.errorMessage = '';

        try {
            await this._authenticationService.sendValidateRequest(this._scope.credentials.email);
            await this._messageService.showAlertPopup(this.$translate.instant('client.forgot_password.success'), this.$translate.instant('client.ok'));

            this._setCurrentPage('login');

            this._scope.inProgress = false;
            this._scope.requestSent = true;
            scopeUtils.apply(this._scope);
        } catch (e) {
            this._scope.errorMessage = this.$translate.instant('client.error.reset_password');
            this._scope.inProgress = false;
            this._scope.requestSent = false;
            scopeUtils.apply(this._scope);
        }
    }

    async _preRegisterUser(form) {
        if (this._scope.inProgress) {
            return;
        }

        if (form.$invalid) {
            form.highlightAllErrors();
            return;
        }

        this._scope.inProgress = true;
        this._scope.errorMessage = '';

        const response = await this._authenticationService.checkIfEmailCanRegister(this._scope.presignup.email);
        this._scope.inProgress = false;

        if (response.data.canRegister) {
            this._scope.signup.email = response.data.email;
            this._setCurrentPage('signup');
        } else {
            if (response.data.errorCode === 1) {            // invalid email address
                this._showErrorMessage(response.data.errorMessage);

            } else if (response.data.errorCode === 2) {     // Oauth user existing
                this._scope.credentials.email = response.data.email;
                this._setCurrentPage('login');
                this._showErrorMessage(response.data.errorMessage);

            } else if (response.data.errorCode === 3) {     // user existing
                this._scope.credentials.email = response.data.email;
                this._setCurrentPage('login');
                this._showErrorMessage(response.data.errorMessage);

            } else {                                      // should not go to this case
                this._showErrorMessage(response.data.errorMessage);
            }
        }

        this._scope.presignup.email = '';
    }

    _registerUser(form) {
        if (this._scope.inProgress) {
            return;
        }

        if (form.$invalid) {
            form.highlightAllErrors();
            return;
        }

        this._scope.inProgress = true;
        this._scope.errorMessage = '';

        return this._handleLoggedIn(async () => await this._authenticationService.register(this._scope.signup, this._scope.resetLocalCart), true);
    }
}

module.controller('Cartonomy.Shared.LoginController', LoginController);



// WEBPACK FOOTER //
// ./src/modules/shared/controllers/LoginController.js